import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap-5';
import { deleteOwnedProperty } from '../store/actions/owned_properties';
import OwnedPropertiesList from '../owned_properties_list';


function ContactProperties({ ownedProperties, deleteOwnedProperty }) {
  if (ownedProperties.loading) {
    return (
      <div className="px-3 py-5">
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      </div>
    );
  }

  if (ownedProperties.list.length === 0) {
    return (
      <div className="text-center">
        This contact has no properties
      </div>
    );
  }

  return (
    <OwnedPropertiesList ownedProperties={ownedProperties.list} onDeleteOwnedProperty={deleteOwnedProperty} />
  );
}

ContactProperties.propTypes = {
  deleteOwnedProperty: PropTypes.func.isRequired,
  ownedProperties: PropTypes.object
};

const mapStateToProps = ({ ownedProperties }) => ({ ownedProperties });
export default connect(mapStateToProps, { deleteOwnedProperty })(ContactProperties);
